export default __webpack_public_path__ + "static/media/hongdiem1.eae703c6.png";